import * as React from "react";
import {Fragment} from "react";
import NewThirdPartyLeadNotification from "../../../model/notification/thirdPartyLead/NewThirdPartyLeadNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: NewThirdPartyLeadNotification
}

/**
 * Watcher notification toast body.
 */
const NotificationNewThirdPartyLeadBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Lead {props.notification.data.referenceNumber}</div>
			<div className={"toast-body"}>
				New lead {props.notification.data.referenceNumber} has just arrived
			</div>
		</Fragment>
	);
};

export default NotificationNewThirdPartyLeadBody;
